import { useState } from "react";
import "./OrderCard.css";
import ButtonDownSvg from "../svgs/ButtonDownSvg";
import CubeSvg from "../svgs/CubeSvg";
import { ProductImage } from "../../../../../images/Images";
import ClaimModal from "./ClaimModal";
import Modal from "../../../../../components/modal/Modal";

interface OrderCardProps {
  orderId: string;
  amount: number;
  orderDate: string;
  items: number;
  shippingDetails: {
    name: string;
    address: string;
    phone: string;
  };
  orderStatus: {
    status: string;
    date: string;
  }[];
  orderItems: {
    name: string;
    price: number;
    quantity: number;
    image?: string;
  }[];
}

const OrderCard: React.FC<OrderCardProps> = ({
  orderId,
  amount,
  orderDate,
  items,
  shippingDetails,
  orderStatus,
  orderItems,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showClaimModal, setShowClaimModal] = useState(false);

  return (
    <div
      className={`retail-order-card ${
        isExpanded ? "retail-order-card--expanded" : ""
      }`}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="retail-order-card__header">
        <div className="retail-order-card__icon">
          <CubeSvg />
        </div>
        <div className="retail-order-card__details">
          <p className="retail-order-card__id">
            Order {orderId.toString().slice(0, 8)}
          </p>
          <p className="retail-order-card__amount">
            Amount: ${amount.toFixed(2)}
          </p>
          <p className="retail-order-card__info">
            Order Date: {orderDate} &nbsp; Items: {items}
          </p>
          <div className="retail-order-card__file-claim-mobile">
            <button
              type="button"
              className="retail-order-card__toggle-text-m"
              onClick={(e) => {
                e.stopPropagation();
                setShowConfirmModal(true);
              }}
            >
              File a claim
            </button>
          </div>
        </div>
        <div className="retail-order-card__toggle">
          <div
            className={`retail-order-card__chevron ${
              isExpanded ? "retail-order-card__chevron--rotated" : ""
            }`}
          >
            <ButtonDownSvg />
          </div>
          <div
            className="retail-order-card__toggle-text"
            style={{ cursor: "pointer", color: "#089B14", fontWeight: 600 }}
            onClick={() => setShowConfirmModal(true)}
          >
            File a claim
          </div>
        </div>
      </div>

      {isExpanded && (
        <div className="retail-order-card__content">
          {/* Shipping Details */}
          <h4 className="ss">Shipping Details</h4>

          <div style={{ display: "flex" }}>
            <CubeSvg />
            <div className="retail-order-card__shipping">
              <p>{shippingDetails.name}</p>
              <p>{shippingDetails.address}</p>
              <p>{shippingDetails.phone}</p>
            </div>
          </div>

          {/* Order Status */}
          <div className="retail-order-card__status">
            <ul>
              {orderStatus.map((statusItem, index) => (
                <div className="card__status" key={index}>
                  <li className="retail-order-card__status-item">
                    <span className={`status-dot status`}></span>
                    {statusItem.status}
                  </li>
                  <p>{statusItem.date}</p>
                </div>
              ))}
            </ul>
          </div>

          {/* Order Items */}
          <div className="retail-order-card__items">
            <h4 className="ss">Order Details</h4>

            {orderItems.map((item, index) => (
              <div key={index} className="retail-order-card__item">
                <div className="retail-order-card__item left">
                  <img src={item.image || ProductImage} alt={item.name} />
                  <div className="retail-order-card__item-info">
                    <p>{item.name}</p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "fit-content",
                      }}
                    >
                      <p> ${item.price.toFixed(2)}</p>
                      <span style={{ fontWeight: 200, marginLeft: 10 }}>
                        per unit
                      </span>
                    </div>
                  </div>
                </div>

                <div className="retail-order-card__item right">
                  x{item.quantity}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {showConfirmModal && (
        <Modal
          isOpen={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
        >
          <div className="claim-confirm-modal">
            <h3>Are you sure you want to file a claim for this product?</h3>
            <div className="claim-confirm-modal__actions">
              <button
                className="claim-confirm-modal__btn yes"
                onClick={() => {
                  setShowConfirmModal(false);
                  setShowClaimModal(true);
                }}
              >
                Yes
              </button>
              <button
                className="claim-confirm-modal__btn cancel"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Claim Modal */}
      <ClaimModal
        isOpen={showClaimModal}
        onClose={() => setShowClaimModal(false)}
        onSubmit={(data) => {
          // handle claim submit (e.g. send to API, show toast, etc.)
          setShowClaimModal(false);
        }}
        productName={orderItems[0]?.name}
      />
    </div>
  );
};

export default OrderCard;
